/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Nav_Dashboard_Signed_In_AsInputs */

const en_nav_dashboard_signed_in_as = /** @type {(inputs: Nav_Dashboard_Signed_In_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dashboard — signed in as ${i?.email}`)
};

const es_nav_dashboard_signed_in_as = /** @type {(inputs: Nav_Dashboard_Signed_In_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Panel — sesión iniciada como ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Dashboard — signed in as {email}" |
*
* @param {Nav_Dashboard_Signed_In_AsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_dashboard_signed_in_as = /** @type {((inputs: Nav_Dashboard_Signed_In_AsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Dashboard_Signed_In_AsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_dashboard_signed_in_as(inputs)
	return en_nav_dashboard_signed_in_as(inputs)
});